import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators as dbCreators } from '../afw/store/db';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ContentParser from '../components/ContentParser/ContentParser';
import {Helmet} from 'react-helmet';
// import "./Home.css";
const styles = theme => ({
  loader: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    zIndex: 4
  },
  root: {
    background: "#FFF"
  },
  wrapper: {
    margin: '0px 100px',
    [theme.breakpoints.down('md')]: {
      margin: '0 25px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
    },
  },
  hideOnMedAndDown:{
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
});

class Home extends Component {
  constructor(props){
    super(props);
    this.state={
      data: {
        t_page: {
          page_prop: {
            style: {
              style: {},
              margins: ""
            }
          }
        }
      },
      HomePageData: props.HomePageData
    }
    
  }
  async componentDidMount(){
    const data = await this.handleLoadData();
    this.setState({
      loading: false, 
      data
    });
  }
  mapComponentsToData=async ({prop, value}, components)=>{
    let obj = {};
    const {db} = this.props;
    if(Array.isArray(value)){
      obj[prop] = value.map(component_name=>new db.Model.t_component(components.find((o=>o.component_name === component_name))));
      for(var i = 0; i < obj[prop].length; i++){
        const table = obj[prop][i].datasource.table;
        if(table){
          const data = await db[table].load(obj[prop][i].datasource.loadoptions);
          obj[table] = data.map(o=>new db.Model[table](o));
        }
      }
    }
    return obj;
  }
  handleLoadData=async()=>{
    const {db} = this.props;
    let data = {t_page: new db.Model.t_page()}
    const pageInfo = await db.t_page_layout.load({
      expand: ['t_page', 't_component.t_cd_component'],
    filter: [['t_page.page_name', '=', `Home`], ['layout_parent', '=', null]]
    })
    let t_page = {...pageInfo[0].t_page}
    pageInfo.map(o=>{
      delete o.t_page;
      return o;
    })
    t_page.t_page_layout = pageInfo;
    t_page.t_page_layout[0].t_component = t_page.t_page_layout[0].t_component.filter(o=>o.component_name !== "NavBar");
    data.t_page = new db.Model.t_page(t_page);
    return data;
  }
  handleRenderContent=(t_page_layout)=>{
    return t_page_layout.map((o,i)=>{
      return (
        <ContentParser key={o.layout_id} data={o} index={i} noMargin/>
      )
    })
  }
  render() {
    const {data} = this.state;
    // const t_page_layout = data.t_page && data.t_page.t_page_layout || [];
    const t_page_layout = data.t_page && data.t_page.t_page_layout ? data.t_page.t_page_layout : [];
    let {page_prop} = data.t_page;
    page_prop.style = page_prop.style || {style: {}, margins: ""};
    const {classes} = this.props;
    return (
      <div className={'wholePage '+ classes.root}>
        <Helmet>
          <title>{data.t_page.page_title}</title>
          <meta name="description" content={data.t_page.page_desc} />
        </Helmet>
        {this.handleRenderContent(t_page_layout)}
      </div>
    );
  }
}
Home.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(
  state => ({db: state.db}),
  dispatch => bindActionCreators({...dbCreators}, dispatch)
)(withStyles(styles)(Home));